import { Step } from './components/Step/Step'

import s from './OpeningSteps.module.scss'

interface StepData {
  desktopImage: string
  mobileImage: string
  tabletImage: string
  title: string
  caption?: string | null
}

interface OpeningStepsProps {
  stepsData: StepData[]
  customStepClasses?: string
}

export const OpeningSteps = ({ stepsData, customStepClasses }: OpeningStepsProps) => {
  return (
    <section className={s.OpeningSteps}>
      <div className={s.stepsContainer}>
        {stepsData.map((step, index) => (
          <Step
            key={index}
            desktopImage={step.desktopImage}
            mobileImage={step.mobileImage}
            tabletImage={step.tabletImage}
            title={step.title}
            customClass={customStepClasses}
            caption={step.caption || ''}
          />
        ))}
      </div>
    </section>
  )
}
